import Modal from '../common/Modal'
import OP36Logo from '../../assets/images/logos/OP36_round_icon_gray.png'
import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import MaterialCard from './MaterialCard'
import SubmitButton from '../common/buttons/SubmitButton'
import PropTypes from 'prop-types'

import './MaterialInfoModal.scss'

const MaterialInfoModal = ({ showModal, setShowModal, material, className }) => {
  const { t } = useTranslation()
  const title = useMemo(() => {
    if (material.name.includes('Starter Kit')) {
      return t('materials.infoModal.starterKit')
    } else {
      return material.name
    }
  }, [material, t])

  return (
    <Modal isOpen={showModal} onClose={() => setShowModal(false)} fixedTop>
      <div id='MaterialInfoModal' className='d-flex flex-column align-items-center'>
        <img className='material-modal-logo' src={OP36Logo} alt={t('materials.infoModal.logoAlt')} />
        <div className='material-modal-title'>{title}</div>
        <div className='material-modal-info'>
          <p>
            <Trans
              i18nKey='materials.infoModal.bodyIntro'
              components={{ br: <br /> }}
              values={{ title }}
            />
          </p>
          <p>
            {t('materials.infoModal.bodyCard')}
          </p>
        </div>
        <MaterialCard className={className} material={material} />
        <SubmitButton onClick={() => setShowModal(false)} buttonMessage={t('materials.infoModal.gotIt')} buttonColor='navy-button' />
      </div>
    </Modal>
  )
}

MaterialInfoModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  material: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    photo: PropTypes.shape({
      fileUrl: PropTypes.string.isRequired,
    }),
  }).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
}

export default MaterialInfoModal
